<template>
  <main class="wrapper-content">
    <template v-if="!isLoading">
      <LmFormHeader :title="$t('Hotel')" :name="form.name" />
      <a-tabs :default-active-key="isOnEditMode? '2' : '1'">
        <a-tab-pane key="1" :tab="$t('Edit')">
          <b-card class="border">
            <b-row>
              <LmTextInput
                ref="nameInput"
                class="col-12 col-md-6"
                :label="$t('Name')"
                v-model="$v.form.name.$model"
                :v="v('form.name')"
              />

              <LmTextArea
                class="col-12 col-md-6"
                :label="$t('Description')"
                v-model="form.description"
              />

              <LmNumberInputV2
                class="col-12 col-md-6"
                :label="$t('Phone')"
                v-model="form.phone"
              />

              <LmTextInput
                class="col-12 col-md-6"
                :label="$t('Contact')"
                v-model="form.contact"
              />

              <LmEmailInput
                class="col-12 col-md-6"
                :label="$t('Email')"
                v-model="form.email"
              />

              <LmGooglePlacesAutocomplete
                class="col-12 col-md-6"
                label="Direccion"
                @placeChanged="placeChanged"
                @inputLmGooglePlacesAutocomplete="inputLmGooglePlacesAutocomplete"
                :value="form.address"
              />

              <LmLeaFletMap
                :markerLatLng="markerLatLng"
                :centerMapCoordinate="markerLatLng"
                class="col-12 mt-4"
                height="250px"
                />

            </b-row>
          </b-card>
        </a-tab-pane>
        <a-tab-pane v-if="isOnEditMode" key="2" :tab="$t('Daily view')">
          <b-card>
            <LmDailyPrograms
              serviceEndpoint="programs"
              calendarProgramRoute="/programs/todos"
              newProgramRoute="/programs/new"
              passengerEditRoute="/passengers/edit/"
              editProgramRoute="/programs/edit/"
              servicesEditRoute="/services/edit/"
              hotelsEditRoute="/hotels/edit/"
              leadersEditRoute="/leaders/edit/"
              vehiclesEditRoute="/vehicles/edit/"
              :hotelIdToFilter="$route.params.id"
            />
          </b-card>
        </a-tab-pane>
      </a-tabs>

      <div :class="isOnModal ? 'flex items-center gap-1' : 'buttons'">
        <LmButton
          v-if="isOnModal"
          buttonClass="btn-secondary"
          :value="$t('close')"
          @click="onClose"
          :isProcessing="isProcessing"
        />
        <LmButton
          v-else
          buttonClass="btn-secondary"
          :value="$t('go_back')"
          @click="onGoBack"
          :isProcessing="isProcessing"
        />

        <LmButton
          buttonClass="btn-primary"
          :value="$t('save')"
          @click="onSubmit"
          :isProcessing="isProcessing"
        />
        <LmButton
          v-if="isOnEditMode && !form.deleted"
          buttonClass="btn-danger"
          :value="$t('delete')"
          @click="onDeleteConfirmation"
          :isProcessing="isProcessing"
        />
        <LmButton
          v-if="isOnEditMode && form.deleted"
          value="Reactivar"
          buttonClass="btn-success"
          @click="onReactivateConfirmation"
          :isProcessing="isProcessing"
        />

      </div>
    </template>
    <b-row v-else>
      <b-col><b-skeleton type="input"></b-skeleton></b-col>
      <b-col><b-skeleton type="input"></b-skeleton></b-col>
      <b-col md="12" class="my-4">
        <div>
          <div class="d-flex flex-wrap mb-3" style="gap: 1rem">
            <span
              class="p-2 border rounded-lg d-flex align-items-center justify-content-between"
              style="gap: 1rem"
              v-for="(item, index) in 4"
              :key="index"
            >
              <b-skeleton type="avatar"></b-skeleton>
              <b-skeleton width="100px"></b-skeleton>
            </span>
          </div>
          <b-skeleton type="button" width="150px"></b-skeleton>
        </div>
      </b-col>
    </b-row>
  </main>
</template>

<script>
// Components
import LmButton from '@/components/form/elements/LmButton'
import LmDatePicker from '@/components/form/elements/LmDatePicker'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmTextInput from '../../components/form/elements/LmTextInput.vue'
import LmEditor from '@/components/form/elements/lmEditor'
import LmTextArea from '../../components/form/elements/LmTextArea.vue'
import LmGooglePlacesAutocomplete from '@/components/LmGooglePlacesAutocomplete.vue'
import LmLeaFletMap from '@/components/LmLeaFletMap.vue'
import LmDailyPrograms from '@/views/lumbretravel/LmDailyPrograms'
import LmNumberInputV2 from '@/components/form/elements/LmNumberInputV2.vue'
import LmEmailInput from '@/components/form/elements/LmEmailInput.vue'
// Utils
import { required } from 'vuelidate/lib/validators'

// Mixins
import lmStandardFormHelperMixin from '@/mixins/lmStandardFormHelperMixin'

export default {
  mixins: [lmStandardFormHelperMixin],
  components: {
    LmDatePicker,
    LmTextInput,
    LmNumberInputV2,
    LmTextArea,
    LmEditor,
    LmTreeSelect,
    LmGooglePlacesAutocomplete,
    LmLeaFletMap,
    LmDailyPrograms,
    LmButton,
    LmEmailInput
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    isOnModal: {
      type: Boolean,
      default: false
    },
    serviceEndpoint: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      // Por defecto la geo es en calafate
      markerLatLng: [-50.337969, -72.2647981],
      form: {
        name: '',
        address: '',
        addressLatLong: [],
        description: '',
        deleted: false,
        phone: '',
        email: '',
        contact: ''
      },
      isProcessing: true
    }
  },
  validations: {
    form: {
      name: { required }
    }
  },
  methods: {
    placeChanged (place) {
      const latLong = [
        place.geometry.location.lat(),
        place.geometry.location.lng()
      ]
      this.markerLatLng = latLong
      this.form.addressLatLong = latLong
      this.form.address = place.formatted_address
    },

    inputLmGooglePlacesAutocomplete (value) {
      if (!value) {
        this.markerLatLng = []
        this.form.addressLatLong = []
        this.form.address = ''
      }
    }
  }
}
</script>
